export class ChangeFormantPrint {
    transactionIdRepresentationImpresedDocument: number;
    formatPrintComprobantRepresentationImpresed: number;
}